<template>
    <div>

        <sub-menu-faturamento 
            v-if="tipo != 'atendimentos-guias'" 
            ativo="atendimentos-guias" />

        <div class="card dashcard mb-0">
            <div class="card-body">

                <div class="form-row mb-2"> 
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load(false)" />
                    </div>

                    <div class="col col-12 col-md-3">
                        <div class="input-group mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa fa-building fa-fw" :class="filtros.id_unidade_operacao ? 'text-success' : ''" aria-hidden="true"></i>
                                </span>
                            </div>
                            <select class="form form-control" v-model="filtros.id_unidade_operacao"
                                :disabled="$store.state.user.id_unidade_operacao > 0">
                                <option value="">Todas as Unidades...</option>
                                <option v-for="(und, iux) in $util.unidades_com_tags(true, true)" 
                                    :value="und.id_unidade_operacao" :key="iux">{{ und.search }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="far fa-credit-card"
                            type="select" 
                            optionsMode="aql"
                            optionsData="id_operadora"
                            optionsDisplay="st_operadora"
                            service="operadoras.index"
                            :optionsParm="{ 
                                fatura: true,
                                classes: false,
                                lista: true
                            }"
                            optionsName="operadoras-para-fatura-guias-2"
                            placeholder="Operadora..."
                            v-model="filtros.id_operadora">
                        </az-input>
                    </div>

                </div>

                <div class="form-row">

                    <div class="col col-12 col-md-3">
                        <az-input icon="fas fa-filter"
                            type="select"
                            optionsMode="esp-ativas"
                            optionsName="esp-ativas"
                            optionsData="id_especialidade"
                            placeholder="Todas as Especialidades..."
                            :optionsReload="true"
                            v-model="filtros.id_especialidade" />
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input icon="fas fa-user-md fa-fw" 
                            type="select" 
                            optionsMode="aql"
                            service="medicos.index"
                            optionsName="medicos-guia"
                            optionsData="id_pessoa"
                            placeholder="Todos os Executantes..."
                            :optionsParm="{ ativos: true }"
                            v-model="filtros.id_medico" />
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input 
                            icon="fa-solid fa-user fa-fw"
                            placeholder="Selecionar paciente..."
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="paciente" 
                            :optimized_ac="true">
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa fa-search"
                            type="text"
                            v-model="pesquisar"
                            :shortkey="['ctrl', 'p']"
                            placeholder="Pesquisar por...">                                
                        </az-input>
                    </div>
                </div>

            </div>

        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && exibicao && exibicao.length"></div>
            <div class="determinate" v-else></div>
        </div>
        
        <az-empty-state v-if="!exibicao.length" icon="fa fa-play" msg="Nenhum atendimento identificado." />

        <div v-else>
            <table class="table table-sm bg-white">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Paciente</th>
                        <th>Procedimento</th>
                        <th>Guias</th>
                        <th width="1%">
                            <button type="button" class="btn btn-outline-primary btn-sm" @click="marcar_todos()">Todos</button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(atend, iax) in exibicao" :key="iax">
                        <td>
                            <a href="#" @click.prevent="abrir_atendimento(atend.id_atendimento)" class="card-link">
                                #{{ atend.id_atendimento }}
                            </a>
                            <div class="small text-muted">
                                {{ $util.getFormatDate(atend.dt_inicio) }}
                            </div>
                        </td>
                        <td>
                            {{ atend.paciente.st_nome }}
                            <div class="small text-muted">
                                {{ atend.plano.search }}
                            </div>
                        </td>
                        <td>
                            {{ atend.procedimento.search }}
                            <span v-if="atend.atendimento.atendimento_procedimentos_count > 1" class="badge badge-primary">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                                {{ atend.atendimento.atendimento_procedimentos_count - 1 }}
                            </span>
                            <div class="small text-muted">
                                {{ atend.medico.search }}
                            </div>
                        </td>
                        <td class="text-nowrap">
                            <div v-for="(guia, igx) in atend.atendimento.guias" :key="igx">
                                <a href="#" @click.prevent="editar(guia)" class="card-link">
                                    {{ guia.st_numero_interno }}
                                </a> 
                                <span class="badge badge-dark mx-2">{{ guia.ch_status }}</span> 
                                {{ $util.formatMoeda(guia.valor_total.total) }}
                            </div>
                        </td>
                        <td>
                            <input type="checkbox" v-model="atend.selecionado" />
                        </td>
                    </tr>
                </tbody>
            </table>

            <br><br><br><br><br>

            <nav class="navbar fixed-bottom navbar-light bg-light pb-3">
                <div class="d-flex">
                    <paginate
                        class="mb-0"
                        :page-count="lista.last_page"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-link'"
                        :next-class="'page-link'"
                        :prev-text="'<<'"
                        :next-text="'>>'"
                        :click-handler="paginar">
                    </paginate>
                </div>

                <div class="d-flex">
                    <div style="width: 150px;" v-if="!isNaN(progresso)">
                        <ProgressBar :value="progresso" :showValue="true">
                            {{ progresso }}%
                        </ProgressBar>
                    </div>
                    <button class="btn btn-sm btn-primary ml-3" @click="regerar_guias()" :disabled="!isNaN(progresso)">
                        <i class="fa-solid fa-retweet"></i>
                    </button>
                </div>
            </nav>

        </div>

        <guia-edicao ref="edicao" />

    </div>
</template>

<script>
import _ from 'lodash';
//import $ from 'jquery';
import SubMenuFaturamento from './SubMenuFaturamento.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import GuiaEdicao from './GuiaEdicao.vue';

export default {
    data () { 
        return {
            guias: null,
            filtros: {
                periodo: 'h', 
                agrupamento: "M", 
                inicio: null,
                fim: null, 
                tipo_data: "", 
                status: "", 
                id_operadora: "", 
                id_plano: "", 
                id_usuario: "", 
                id_unidade_operacao: "", 
                id_contrato_operadora: "", 
                id_classe_procedimento: "", 
                id_recepcao: "",
                id_medico: "",
                id_especialidade: "", 
                id_status_laudo: "", 
                id_motivo_glosa: "", 
                tipo_disponivel: "T",
                mes: "",
                guia_zerada: false, 
                filtro_senha: "", 
                op_filtro: 'PAC',
                texto_laudo: "", 
                codigo: "", 
            },
            filtros_selec: { 
                status: "?"
            },
            paciente: "", 
            selectAll: false,
            statusList: [
                { id: 'PR', display: 'Pendente na Recepção' },
                { id: 'PE', display: 'Pendente no Faturamento' },
            ],
            pesquisar: "",
            firstLoad: false,
            ordem: "",
            faturas: null, 
            unidade_operacao: "",
            usuarios: [], 
            envio_global: false, 
            canceltoken: null, 
            page: 1, 
            paginacao: null, 
            tem_paginacao: false, 
            progresso: 'N', 
            protocolo_para_imprimir: null, 
            dt_retorno: "", 
            validate: false, 
            exibir_matricula: false, 
            show_valor_consumo: false,
            impressao_laudos: false,
            analitico: null,
            sintetico: null, 
            lista: null, 
        }
    },
    
    props: [ 'status', 'tipo', 'id_operadora', 'mes', 'id_usuario' ],

    components: { 
        AzEmptyState,
        AzInput,
        AzPeriodo, 
        SubMenuFaturamento,
        GuiaEdicao, 
    },

    computed: { 
        exibicao: function ()  {
            if ( !this.lista || !this.lista.data ) 
                return [];

            if ( this.pesquisar.slice(0,1) != '#' ) { 
                let reg = this.$util.getregex(this.pesquisar);

                return this.lista.data.filter(item => ( !this.pesquisar || reg.test(JSON.stringify(item)) ));
            }

            return this.lista.data;
        },

        selecteds: function () { 
            if ( !this.exibicao || !this.exibicao.length ) 
                return [];

            return this.exibicao.filter( x => x.selecionado );
        }
    },

    methods: { 
        processar_chunk(lista, func) { 

            this.progresso = Math.round( ( ( this.selecteds.length - lista.length ) / this.selecteds.length ) * 100 );

            let items = _.slice(lista, 0, 25);
            lista = _.slice(lista, 25, lista.length);

            this.$store.commit('loading', true);

            this.$util.atualizar(this, { 
                service: 'guias',
                func: func,
                dados: { 
                    qtd: this.selecteds.length, 
                    parte: items.length,
                    falta: lista.length, 
                    atendimentos: items.map(item => { 
                        return { 
                            id_atendimento: item.id_atendimento,
                        };
                    }), 
                },
                continue_loading: lista.length ? true : false, 
                callback: () => { 
                    if ( lista.length ) { 
                        this.processar_chunk(lista, func);
                    } else { 
                        this.progresso = 100;
                        this.load(false);
                        this.progresso = 'N';

                        this.$toast.add({
                            severity: "success",
                            summary: "Atenção",
                            detail: "Processo concluído.",
                            life: 3000
                        });
                    }
                }

            });

        },

        regerar_guias () { 
            if ( !confirm ('Confirma regerar as guias selecionadas?') ) 
                return;

            this.processar_chunk(this.selecteds, 'regerar_guias');
        },

        marcar_todos () { 
            let marcados = this.exibicao.filter( x => x.selecionado ).length;
            this.exibicao.forEach(element => {
                element.selecionado = marcados ? false : true;
            });
        },

        paginar (page) {
            this.page = page;
            this.load(false);
        },

        editar (guia) { 
            this.$refs.edicao.abrir(guia);
        },

        abrir_atendimento(id_atendimento) { 
            this.$util.abrir_atendimento(this, id_atendimento);
        },

        load(showSpinner = true) { 
        
            if ( !this.filtros.id_operadora ) { 
                this.filtros.id_contrato_operadora = "";
                this.filtros.id_plano = "";
            }

            if ( showSpinner )
                this.guias = null;

            this.$util.load(this, { 
                service: 'guias',
                func: 'atendimento_guias', 
                parms: { 
                    ...this.filtros,
                    page: this.page,
                    pesquisar: this.pesquisar, 
                    id_paciente: this.paciente ? this.paciente.id_pessoa : null, 
                },
                loadTo: res => { 
                    res.data.forEach(element => {
                        element.selecionado = false;
                    });

                    this.lista = res;

                    if ( this.lista.last_page < this.page && this.page > 1 )
                        this.page = 1;

                    if ( this.lista.last_page > 1 ) { 
                        this.tem_paginacao = true;
                    }
                }
            });

        }

    },

    mounted() { 

        this.exibir_matricula = this.$util.getCookie('fat-em') == 'S' ? true : false; 

        this.$store.commit('setBreadcrumb', 
            [
                { name: "Faturamento", path: "/faturamento/visao"},
                { name: "Atendimento Guias", path: "/faturamento/atendimentos-guias"},
            ]);

    }

}
</script>